export interface Attribute<T> {
  readonly param: string
  readonly decode: (raw: string) => T | undefined
}

export type Contract = Readonly<Record<string, Attribute<unknown>>>

export type Values<C extends Contract> = {
  [K in keyof C]?: C[K] extends Attribute<infer T> ? T : never
}

export function stringAttribute(param: string): Attribute<string> {
  return {
    param,
    decode: (raw) => raw || undefined,
  }
}

export function enumAttribute<T extends string>(
  param: string,
  allowed: readonly T[]
): Attribute<T> {
  return {
    param,
    decode: (raw) => allowed.find((candidate) => candidate === raw),
  }
}
